import React, { FC } from 'react'
import styles from 'styles/components/card.module.scss'
import text from 'styles/utility/text.module.scss'
import { CardGreyHeadline } from 'components/Card'

type Props = {
  maximumOrder: number
}

const DeliveryScheduleConfirmCard: FC<Props> = React.memo((props) => {
  const { maximumOrder } = props
  return (
    <div className={styles.settings}>
      <div className={styles.settings__header}>
        <h4 className={styles.settings__header__title}>お届け可能日の設定</h4>
      </div>
      <CardGreyHeadline headline={'1日の販売上限数'} />
      <div className={styles.settings__body}>
        <p className={`${text.font_small}`}>
          <span className={`${text.font_bold}`}>{maximumOrder}個</span>
        </p>
      </div>
    </div>
  )
})

export default DeliveryScheduleConfirmCard
